import React, { Component } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const LANGUAGES = ['en', 'sv'];

class Header extends Component {
    getPageTitle() {
        const pathname = this.props[0] && this.props[0].location ? this.props[0].location.pathname : window.location.pathname;
        const matches = (path) => !!path && (pathname === path || pathname.indexOf(path + '/') === 0);

        for (const item of this.props.modulesTree || []) {
            const submodule = item.modules && item.modules.find((submodule) => matches(submodule.path));
            if (submodule)
                return submodule.name;
            if (matches(item.path))
                return item.name;
        }
        return null;
    }

    render() {
        const title = this.getPageTitle();

        return (
            <header className="header">
                <h1 className="header-title">{title}</h1>

                <div className="header-actions">
                    <UncontrolledDropdown className="header-lang">
                        <DropdownToggle caret>
                            {this.props.lang.toUpperCase()}
                        </DropdownToggle>
                        <DropdownMenu right>
                            {
                                LANGUAGES.map((lang) => (
                                    <DropdownItem key={lang} active={this.props.lang == lang} onClick={() => this.props.changeLang(lang)}>{lang.toUpperCase()}</DropdownItem>
                                ))
                            }
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </header>
        )
    }
}

export default Header;
